import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import odontogramHelper from "../helper";
import Anomali from "./legends/Anomali";
import BridgeCenter from "./legends/BridgeCenter";
import BridgeCenterReverse from "./legends/BridgeCenterReverse";
import BridgeEnd from "./legends/BridgeEnd";
import BridgeEndReverse from "./legends/BridgeEndReverse";
import BridgeStart from "./legends/BridgeStart";
import BridgeStartReverse from "./legends/BridgeStartReverse";
import FullDentureAcrylic from "./legends/FullDentureAcrylic";
import FullDentureMetal from "./legends/FullDentureMetal";
import ImplantPorcelainCrown from "./legends/ImplantPorcelainCrown";
import Karang from "./legends/Karang";
import None from "./legends/None";
import PartialDentureAcrylic from "./legends/PartialDentureAcrylic";
import PartialDentureMetal from "./legends/PartialDentureMetal";
import PartialErupt from "./legends/PartialErupt";
import RootBlack from "./legends/RootBlack";
import RootWhite from "./legends/RootWhite";
import UnErupted from "./legends/UnErupted";
import BottomLeftRotation from "./rotations/BottomLeftRotation";
import BottomRightRotation from "./rotations/BottomRightRotation";
import LeftMigration from "./rotations/LeftMigration";
import LeftRotation from "./rotations/LeftRotation";
import RightMigration from "./rotations/RightMigration";
import RightRotation from "./rotations/RightRotation";
import TopLeftRotation from "./rotations/TopLeftRotation";
import TopRightRotation from "./rotations/TopRightRotation";
import {
  bold__outline__mark,
  cross__mark,
  disabled__mark,
  foursec__bottom,
  foursec__bottom__amf,
  foursec__bottom__car,
  foursec__bottom__cof,
  foursec__bottom__fis,
  foursec__left,
  foursec__left__amf,
  foursec__left__car,
  foursec__left__cof,
  foursec__left__fis,
  foursec__right,
  foursec__right__amf,
  foursec__right__car,
  foursec__right__cof,
  foursec__right__fis,
  foursec__top,
  foursec__top__amf,
  foursec__top__car,
  foursec__top__cof,
  foursec__top__fis,
  gold__bold__outline__mark,
  hash__mark,
  index__text,
  karang__container,
  legend__container,
  rotation__container,
  sec__container,
  silver__bold__outline__mark,
  stripe__mark,
  tooth__container,
  v__mark,
} from "./style";

export default function FourSectionTooth({
  data,
  teethMode,
  handleToothClick,
}) {
  const [style, setStyle] = useState({
    container: sec__container,
    top: foursec__top,
    bottom: foursec__bottom,
    left: foursec__left,
    right: foursec__right,
  });

  const [rotation, setRotation] = useState({
    top: <></>,
    bottom: <></>,
  });

  const [legend, setLegend] = useState({
    top: <></>,
    bottom: <></>,
  });

  const [karang, setKarang] = useState("");

  const containerStyleBuilder = () => {
    const baseStyle = sec__container;
    if (odontogramHelper.isDisabled(data, teethMode)) {
      setStyle((prev) => ({
        ...prev,
        container: { ...baseStyle, ...disabled__mark },
      }));
      setLegend({
        top: <></>,
        bottom: <></>,
      });
      setRotation({
        top: <></>,
        bottom: <></>,
      });
    } else {
      let globalData = data[1] ?? [];
      if (globalData.length > 0 && globalData[0].length > 0) {
        let mode = globalData[0];
        let useDefaultStyle = true;
        if (mode === "FLMB" || mode === "ICLB") {
          useDefaultStyle = false;
          if (odontogramHelper.isTopGroupIndex(data[0])) {
            setLegend({
              top: <BridgeStart />,
              bottom: "",
            });
          } else {
            setLegend({
              top: "",
              bottom: <BridgeStartReverse />,
            });
          }
          setStyle((prev) => ({
            ...prev,
            container: { ...baseStyle, ...bold__outline__mark },
          }));
        } else if (mode === "IPCB") {
          useDefaultStyle = false;
          if (odontogramHelper.isTopGroupIndex(data[0])) {
            setLegend({
              top: <BridgeStart />,
              bottom: "",
            });
          } else {
            setLegend({
              top: "",
              bottom: <BridgeStartReverse />,
            });
          }
          setStyle((prev) => ({
            ...prev,
            container: {
              ...baseStyle,
              ...bold__outline__mark,
              ...stripe__mark,
            },
          }));
        } else if (mode === "BWS") {
          useDefaultStyle = false;
          if (odontogramHelper.isTopGroupIndex(data[0])) {
            setLegend({
              top: <BridgeCenter />,
              bottom: "",
            });
          } else {
            setLegend({
              top: "",
              bottom: <BridgeCenterReverse />,
            });
          }
          setStyle((prev) => ({
            ...prev,
            container: {
              ...baseStyle,
              ...bold__outline__mark,
              ...cross__mark,
            },
          }));
        } else if (mode === "BWE") {
          useDefaultStyle = false;
          if (odontogramHelper.isTopGroupIndex(data[0])) {
            setLegend({
              top: <BridgeEnd />,
              bottom: "",
            });
          } else {
            setLegend({
              top: "",
              bottom: <BridgeEndReverse />,
            });
          }
          setStyle((prev) => ({
            ...prev,
            container: {
              ...baseStyle,
              ...bold__outline__mark,
            },
          }));
        } else if (mode === "BWPL") {
          useDefaultStyle = false;
          if (odontogramHelper.isTopGroupIndex(data[0])) {
            setLegend({
              top: <BridgeCenter />,
              bottom: "",
            });
          } else {
            setLegend({
              top: "",
              bottom: <BridgeCenterReverse />,
            });
          }
          setStyle((prev) => ({
            ...prev,
            container: {
              ...baseStyle,
              ...bold__outline__mark,
              ...stripe__mark,
            },
          }));
        } else if (mode === "BWEPL") {
          useDefaultStyle = false;
          if (odontogramHelper.isTopGroupIndex(data[0])) {
            setLegend({
              top: <BridgeEnd />,
              bottom: "",
            });
          } else {
            setLegend({
              top: "",
              bottom: <BridgeEndReverse />,
            });
          }
          setStyle((prev) => ({
            ...prev,
            container: {
              ...baseStyle,
              ...bold__outline__mark,
              ...stripe__mark,
            },
          }));
        } else if (mode === "SSAK") {
          useDefaultStyle = false;
          setLegend({
            top: "",
            bottom: "",
          });
          setStyle((prev) => ({
            ...prev,
            container: {
              ...baseStyle,
              ...v__mark,
            },
          }));
        } else if (mode === "ANOM") {
          if (odontogramHelper.isTopGroupIndex(data[0])) {
            setLegend({
              top: <Anomali />,
              bottom: "",
            });
          } else {
            setLegend({
              top: "",
              bottom: <Anomali />,
            });
          }
        } else if (mode === "UERU") {
          if (odontogramHelper.isTopGroupIndex(data[0])) {
            setLegend({
              top: <UnErupted />,
              bottom: "",
            });
          } else {
            setLegend({
              top: "",
              bottom: <UnErupted />,
            });
          }
        } else if (mode === "PAERU") {
          if (odontogramHelper.isTopGroupIndex(data[0])) {
            setLegend({
              top: <PartialErupt />,
              bottom: "",
            });
          } else {
            setLegend({
              top: "",
              bottom: <PartialErupt />,
            });
          }
        } else if (mode === "GGTA") {
          if (odontogramHelper.isTopGroupIndex(data[0])) {
            setLegend({
              top: <None />,
              bottom: "",
            });
          } else {
            setLegend({
              top: "",
              bottom: <None />,
            });
          }
        } else if (mode === "GGHG") {
          setLegend({
            top: "",
            bottom: "",
          });
          useDefaultStyle = false;
          setStyle((prev) => ({
            ...prev,
            container: { ...baseStyle, ...cross__mark },
          }));
        } else if (mode === "FRAK") {
          useDefaultStyle = false;
          setLegend({
            top: "",
            bottom: "",
          });
          setStyle((prev) => ({
            ...prev,
            container: { ...baseStyle, ...hash__mark },
          }));
        } else if (
          mode === "PLC" ||
          mode === "MPLC" ||
          mode === "GMC" ||
          mode === "IPLC"
        ) {
          useDefaultStyle = false;
          let outlineMark;
          if (mode === "PLC" || mode === "IPLC") {
            outlineMark = bold__outline__mark;
          } else if (mode === "MPLC") {
            outlineMark = silver__bold__outline__mark;
          } else {
            outlineMark = gold__bold__outline__mark;
          }
          if (odontogramHelper.isTopGroupIndex(data[0])) {
            setLegend({
              top: mode === "IPLC" ? <ImplantPorcelainCrown /> : "",
              bottom: "",
            });
          } else {
            setLegend({
              top: "",
              bottom: mode === "IPLC" ? <ImplantPorcelainCrown /> : "",
            });
          }
          setStyle((prev) => ({
            ...prev,
            container: {
              ...baseStyle,
              ...stripe__mark,
              ...outlineMark,
            },
          }));
        } else if (mode === "FLMC") {
          useDefaultStyle = false;
          setStyle((prev) => ({
            ...prev,
            container: {
              ...baseStyle,
              ...bold__outline__mark,
            },
          }));
        } else if (
          mode === "PADA" ||
          mode === "FLDA" ||
          mode === "PADM" ||
          mode === "FLDM"
        ) {
          useDefaultStyle = false;
          setStyle((prev) => ({
            ...prev,
            container: {
              ...baseStyle,
              ...cross__mark,
            },
          }));
          let legend;
          if (mode === "PADA") {
            legend = <PartialDentureAcrylic />;
          } else if (mode === "FLDA") {
            legend = <FullDentureAcrylic />;
          } else if (mode === "PADM") {
            legend = <PartialDentureMetal />;
          } else {
            legend = <FullDentureMetal />;
          }
          if (odontogramHelper.isTopGroupIndex(data[0])) {
            setLegend({
              top: legend,
              bottom: "",
            });
          } else {
            setLegend({
              top: "",
              bottom: legend,
            });
          }
        }
        if (useDefaultStyle === true) {
          setStyle((prev) => ({
            ...prev,
            container: baseStyle,
          }));
        }
      } else {
        setStyle((prev) => ({
          ...prev,
          container: { ...baseStyle },
        }));
        setLegend({
          top: "",
          bottom: "",
        });
      }
    }
  };

  const resetSectionStyle = (sectionName = null) => {
    if (sectionName === null) {
      setStyle((prev) => ({
        ...prev,
        top: foursec__top,
        bottom: foursec__bottom,
        left: foursec__left,
        right: foursec__right,
      }));
    } else {
      if (sectionName === "top") {
        setStyle((prev) => ({
          ...prev,
          top: foursec__top,
        }));
      } else if (sectionName === "bottom") {
        setStyle((prev) => ({
          ...prev,
          bottom: foursec__bottom,
        }));
      } else if (sectionName === "left") {
        setStyle((prev) => ({
          ...prev,
          left: foursec__left,
        }));
      } else if (sectionName === "right") {
        setStyle((prev) => ({
          ...prev,
          right: foursec__right,
        }));
      }
    }
  };

  const sectionStyleBuilder = () => {
    if (
      odontogramHelper.isGlobalStyleApplied(data) ||
      odontogramHelper.isDisabled(data, teethMode)
    ) {
      resetSectionStyle();
    } else {
      /**
       * part
       * 4-part atas, kanan, bawah, kiri
       */
      let sectionNameList = ["top", "right", "bottom", "left"];
      let sectionData = data[2];
      if (Array.isArray(sectionData)) {
        sectionData.forEach((sec, idx) => {
          let sectionName = sectionNameList[idx];
          if (sec.length < 1) {
            resetSectionStyle(sectionName);
          } else {
            let mode = sec;
            if (sectionName === "top") {
              if (mode === "TAA") {
                setStyle((prev) => ({
                  ...prev,
                  top: foursec__top__amf,
                }));
              } else if (mode === "TAC") {
                setStyle((prev) => ({
                  ...prev,
                  top: foursec__top__cof,
                }));
              } else if (mode === "PFS") {
                setStyle((prev) => ({
                  ...prev,
                  top: foursec__top__fis,
                }));
              } else if (mode === "KAR") {
                setStyle((prev) => ({
                  ...prev,
                  top: foursec__top__car,
                }));
              } else {
                resetSectionStyle(sectionName);
              }
            } else if (sectionName === "right") {
              if (mode === "TAA") {
                setStyle((prev) => ({
                  ...prev,
                  right: foursec__right__amf,
                }));
              } else if (mode === "TAC") {
                setStyle((prev) => ({
                  ...prev,
                  right: foursec__right__cof,
                }));
              } else if (mode === "PFS") {
                setStyle((prev) => ({
                  ...prev,
                  right: foursec__right__fis,
                }));
              } else if (mode === "KAR") {
                setStyle((prev) => ({
                  ...prev,
                  right: foursec__right__car,
                }));
              } else {
                resetSectionStyle(sectionName);
              }
            } else if (sectionName === "bottom") {
              if (mode === "TAA") {
                setStyle((prev) => ({
                  ...prev,
                  bottom: foursec__bottom__amf,
                }));
              } else if (mode === "TAC") {
                setStyle((prev) => ({
                  ...prev,
                  bottom: foursec__bottom__cof,
                }));
              } else if (mode === "PFS") {
                setStyle((prev) => ({
                  ...prev,
                  bottom: foursec__bottom__fis,
                }));
              } else if (mode === "KAR") {
                setStyle((prev) => ({
                  ...prev,
                  bottom: foursec__bottom__car,
                }));
              } else {
                resetSectionStyle(sectionName);
              }
            } else if (sectionName === "left") {
              if (mode === "TAA") {
                setStyle((prev) => ({
                  ...prev,
                  left: foursec__left__amf,
                }));
              } else if (mode === "TAC") {
                setStyle((prev) => ({
                  ...prev,
                  left: foursec__left__cof,
                }));
              } else if (mode === "PFS") {
                setStyle((prev) => ({
                  ...prev,
                  left: foursec__left__fis,
                }));
              } else if (mode === "KAR") {
                setStyle((prev) => ({
                  ...prev,
                  left: foursec__left__car,
                }));
              } else {
                resetSectionStyle(sectionName);
              }
            }
          }
        });
      } else {
        resetSectionStyle();
      }
    }
  };

  const rotationLegendHandler = () => {
    if (odontogramHelper.isDisabled(data, teethMode)) {
      setRotation((prev) => ({
        top: <></>,
        bottom: <></>,
      }));
      return;
    }
    let validTop = ["MAK1", "MAK2", "RAK1", "RAK2"];
    if (
      data[3] !== undefined &&
      data[3].length > 0 &&
      validTop.includes(data[3])
    ) {
      let mode = data[3];
      if (mode === "MAK1") {
        setRotation((prev) => ({
          ...prev,
          top: <RightMigration />,
        }));
      } else if (mode === "MAK2") {
        setRotation((prev) => ({
          ...prev,
          top: <LeftMigration />,
        }));
      } else if (mode === "RAK1") {
        setRotation((prev) => ({
          ...prev,
          top: <TopRightRotation />,
        }));
      } else {
        setRotation((prev) => ({
          ...prev,
          top: <TopLeftRotation />,
        }));
      }
    } else {
      setRotation((prev) => ({
        ...prev,
        top: <></>,
      }));
    }

    let validBottom = ["MBK1", "MBK2", "RBK1", "RBK2", "GGNV", "PSA"];
    if (
      data[4] !== undefined &&
      data[4].length > 0 &&
      validBottom.includes(data[4])
    ) {
      let mode = data[4];
      if (mode === "MBK1") {
        setRotation((prev) => ({
          ...prev,
          bottom: <RightMigration />,
        }));
      } else if (mode === "MBK2") {
        setRotation((prev) => ({
          ...prev,
          bottom: <LeftMigration />,
        }));
      } else if (mode === "RBK1") {
        setRotation((prev) => ({
          ...prev,
          bottom: <BottomRightRotation />,
        }));
      } else if (mode === "RBK2") {
        setRotation((prev) => ({
          ...prev,
          bottom: <BottomLeftRotation />,
        }));
      } else if (mode === "GGNV") {
        setRotation((prev) => ({
          ...prev,
          bottom: <RootWhite />,
        }));
      } else if (mode === "PSA") {
        setRotation((prev) => ({
          ...prev,
          bottom: <RootBlack />,
        }));
      } else {
        setRotation((prev) => ({
          ...prev,
          bottom: <></>,
        }));
      }
    } else {
      setRotation((prev) => ({
        ...prev,
        bottom: <></>,
      }));
    }
  };

  const karangLegendHandler = () => {
    if (odontogramHelper.isDisabled(data, teethMode)) {
      setKarang("");
      return;
    }
    if (data[5] !== undefined && data[5].length > 0 && data[5] === "KARANG") {
      setKarang(<Karang />);
    } else {
      setKarang("");
    }
  };

  useEffect(() => {
    containerStyleBuilder();
    sectionStyleBuilder();
    rotationLegendHandler();
    karangLegendHandler();
  }, [data, teethMode]);

  return (
    <>
      <Box sx={tooth__container}>
        {odontogramHelper.isTopGroupIndex(data[0]) && (
          <Box>
            <Typography sx={index__text}>{data[0] ?? 0}</Typography>
          </Box>
        )}
        <Box data-name="karang" sx={karang__container}>
          {karang}
        </Box>
        <Box data-name="top-rotation" sx={rotation__container}>
          {rotation.top}
        </Box>
        <Box data-name="top-legends" sx={legend__container}>
          {legend.top}
        </Box>
        <Box
          sx={style.container}
          onClick={(e) => {
            handleToothClick(e, data);
          }}
        >
          <Box sx={style.top} data-group="sec_top"></Box>
          <Box sx={style.bottom} data-group="sec_bottom"></Box>
          <Box sx={style.left} data-group="sec_left"></Box>
          <Box sx={style.right} data-group="sec_right"></Box>
        </Box>
        <Box data-name="bottom-legends" sx={legend__container}>
          {legend.bottom}
        </Box>
        <Box data-name="bottom-rotation" sx={rotation__container}>
          {rotation.bottom}
        </Box>
        {odontogramHelper.isBottomGroupIndex(data[0]) && (
          <Box>
            <Typography sx={index__text}>{data[0] ?? 0}</Typography>
          </Box>
        )}
      </Box>
    </>
  );
}
